import { backendUrl } from "../Router/constant";

const getProfileImage = (vendor) => {
  const candidates = [
    vendor?.profileImageUrl,
    vendor?.profileImage,
    vendor?.profileImageId,
    vendor?.profilePicture,
    vendor?.profilePictureId,
    vendor?.image,
    vendor?.imageId,
    vendor?.avatar,
    vendor?.avatarId,
  ];
  const image = candidates.find(Boolean);
  if (!image) return "";

  if (typeof image === "object") {
    const url = image.url || image.src;
    if (url) return url;
  }

  const imageValue =
    typeof image === "string"
      ? image
      : image?._id || image?.id || image?.uploadId || "";
  if (!imageValue) return "";
  if (/^(https?:|data:|blob:)/i.test(imageValue)) return imageValue;
  if (imageValue.startsWith("/assets/")) return imageValue;
  if (imageValue.startsWith("/api/uploads/")) {
    return backendUrl.replace(/\/api$/, "") + imageValue;
  }
  if (imageValue.startsWith("/uploads/")) return backendUrl + imageValue;

  return `${backendUrl}/uploads/${encodeURIComponent(imageValue)}`;
};

export const getVendorProfileView = (vendor = {}) => {
  const name =
    vendor?.name ||
    vendor?.fullName ||
    [vendor?.firstName, vendor?.lastName].filter(Boolean).join(" ").trim();
  const email = vendor?.username || vendor?.email || "";

  return {
    name,
    email,
    imageUrl: getProfileImage(vendor),
    initial: (name || email).trim().charAt(0).toUpperCase() || "U",
  };
};